import { CircleCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";

const EditProductSuccess = ({ closeEditProductSuccess }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={(e) => {
        closeEditProductSuccess();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[500px] h-[250px] flex flex-col justify-center items-center gap-[10px] rounded-[10px] p-[20px] relative bg-white"
      >
        <CircleCheck color="#00A676" />
        <p className="text-[#5C5C5C] text-[16px] font-semibold">
          Success! Product Edited
        </p>
        <p className="text-[#5C5C5C] text-[16px] text-center font-semibold">
          The product has been edited and is now available in your product list.
        </p>
        <div className="flex items-center justify-center gap-[15px]">
          <button
            onClick={closeEditProductSuccess}
            className="h-[35px] rounded-[30px] bg-[#F3F3F3] px-[20px] text-[#5C5C5C] font-medium text-[15px]"
          >
            Close
          </button>
          <button
            onClick={() => navigate("/dashboard/loan-products")}
            className="h-[35px] bg-[#000000] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            View Products
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditProductSuccess;
